import React, { useEffect, useState } from "react"
import { withTranslation } from "react-i18next"
import ReactSVG from "react-svg"
import { Button } from "semantic-ui-react"
import CrossLogo from "../../../images/rewards/cross.svg"
import EarnRewardWays from "./EarnRewardWays"
import DrivingMilesLogo from "../../../images/rewards/driving-miles.svg"
import MaintainVehicleLogo from "../../../images/rewards/maintain-vehicle.svg"
import UseCarAdviseLogo from "../../../images/rewards/by-using-caradvise.svg"
import EarnedMiles from "./EarnedMiles"
import { routeChange, routerPaths } from "../../../v1/constants/paths"
import { withRouter } from "react-router-dom"
import {
  DAYS,
  DEFAULT_VISIBLE_EXPIRY_REWARDS,
  DEFAULT_VISIBLE_TIME_REWARDS,
  EARN,
  FALSE,
  LAST_VISIT,
  OPEN_REWARSD_WORKS_DIALOG,
  SHOW_REWARDS_SECTION,
  gotoRewards
} from "../../../shared_component/constants/rewards"
import { getEarnedMiles, getRewards } from "../../../v1/actions/rewards"
import { connect } from "react-redux"
import store from "../../../shared_component/utils/configureStore"
import Notifications from "../../../v1/components/Notifications"
import ButtonWithIcon from "../../../shared_component/components/Button/ButtonWithIcon"
import AccountLockLogo from "../../../images/rewards/create-account-lock.svg"
import { getLocalStorage, setLocalStorage } from "../../../shared_component/utils/cookies"
import moment from "moment"
import { identifyEvent, trackEvent } from "../../../shared_component/utils/segmentAnalytics"
import {
  gaJSON,
  trackFirebaseAnalytics
} from "../../../shared_component/utils/googleAnalyticsHelpers"

const Rewards = ({
  t,
  getRewards,
  getEarnedMiles,
  history,
  user,
  userRewards,
  leftnav,
  earnedMiles = false
}) => {
  const EARN_REWARDS_WAYS = [
    {
      id: 1,
      image: DrivingMilesLogo,
      label: t("drivingMiles")
    },
    {
      id: 2,
      image: MaintainVehicleLogo,
      label: t("maintainingYourVehicle")
    },
    {
      id: 3,
      image: UseCarAdviseLogo,
      label: t("byUsingCarAdvise")
    }
  ]

  const [isRewardsVisible, setIsRewardsVisible] = useState(true)
  const [isLoading, setIsLoading] = useState(false)

  const isDialogOpendExpired = getLocalStorage(OPEN_REWARSD_WORKS_DIALOG) !== FALSE

  const getRewardsData = async () => {
    try {
      setIsLoading(true)
      const completedRewards = await getRewards({ rewardType: EARN })

      if (completedRewards.error) {
        store.dispatch(
          Notifications.error({
            title: t("errorTitle"),
            message: `${completedRewards.error}`,
            position: "tr",
            autoDismiss: 5,
            action: {
              label: "Dismiss"
            }
          })
        )
      }
    } catch (error) {
      console.log(t("errorInGetRewardsData"), error)
    } finally {
      setIsLoading(false)
    }
  }

  const handleEarnedRewards = async () => {
    try {
      const rewardsRes = await getEarnedMiles()

      if (rewardsRes.error) {
        store.dispatch(
          Notifications.error({
            title: t("errorTitle"),
            message: `${rewardsRes.error}`,
            position: "tr",
            autoDismiss: 5,
            action: {
              label: "Dismiss"
            }
          })
        )
      }
    } catch (error) {
      console.log(t("errorInEarnRewardsData"), error)
    }
  }

  const checkRewardsVisibility = () => {
    const lastInteraction = getLocalStorage(LAST_VISIT)
    if (!lastInteraction) {
      setLastInteractionTimestamp()
    }
    const showSectionCookie = getLocalStorage(SHOW_REWARDS_SECTION)
    if (showSectionCookie === FALSE) {
      setIsRewardsVisible(false)
    } else {
      const lastVisit = moment(lastInteraction)
      const now = moment()
      const daysSinceLastVisit = now.diff(lastVisit, DAYS)
      if (daysSinceLastVisit > DEFAULT_VISIBLE_TIME_REWARDS) {
        setIsRewardsVisible(false)
      } else {
        setIsRewardsVisible(true)
      }
    }
  }

  const handleRewardsSectionVisibility = () => {
    setIsRewardsVisible(false)
    setLocalStorage(SHOW_REWARDS_SECTION, FALSE)
    setLocalStorage(LAST_VISIT, moment().format())
  }

  // Function to set the timestamp of the last interaction in localStorage
  const setLastInteractionTimestamp = () => {
    setLocalStorage(LAST_VISIT, moment().format())
  }

  useEffect(() => {
    getRewardsData()
    handleEarnedRewards()
    checkRewardsVisibility()
  }, [])

  return isRewardsVisible ? (
    <div className={`rewards-container ${leftnav ? "rewards_override_width" : ""}`}>
      <div className="rewards-header">
        <p className="rewards-title">{t("introduceRewards")}</p>
        <ReactSVG
          onClick={handleRewardsSectionVisibility}
          src={CrossLogo}
          className="rewards-cross"
        />
      </div>
      <div className="rewards-earned">
        <p className="rewards-earned-title">{t("youEarned")}</p>
        <p className="rewards-earned-miles">
          {earnedMiles} {t("miles")}{" "}
        </p>
      </div>
      <div className="rewards-earned-miles-services">
        {isLoading
          ? [...new Array(2)].map(() => <div className="earn_miles_shimmer"></div>)
          : userRewards &&
            userRewards.length > 0 &&
            userRewards
              .slice(0, 2)
              .map((earnedMiles) => <EarnedMiles key={earnedMiles.id} earnedMiles={earnedMiles} />)}
      </div>
      <p className="rewards-earn">{t("earnRewards")}</p>

      <div className="rewards-ways">
        {EARN_REWARDS_WAYS.map((ways) => (
          <EarnRewardWays key={ways.id} earnedMileageWays={ways} />
        ))}
      </div>
      {user && !user.generic && (
        <Button
          content={t("earnMore")}
          className="earn-more-rewards"
          onClick={() => {
            if (isDialogOpendExpired) {
              setLocalStorage(OPEN_REWARSD_WORKS_DIALOG, true)
            }
            identifyEvent({
              traits: {},
              userId: user.id
            })
            trackEvent("rewards-earn-more-clicked", {})
            trackFirebaseAnalytics({
              event: gaJSON.rewards_earn_more_clicked
            })
            routeChange(history, routerPaths.rewards)
          }}
        />
      )}
      {user.generic && (
        <ButtonWithIcon
          logo={AccountLockLogo}
          onClick={() => {
            gotoRewards(history)
          }}
          btnLabel={t("earnMilesPerOrder:createAccountAndEarn")}
        />
      )}
    </div>
  ) : null
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    userRewards:
      state.rewards && state.rewards.userRewards && state.rewards.userRewards.length > 0
        ? state.rewards.userRewards
        : [],
    leftnav: state && state.leftnav && state.leftnav.navOpen,
    earnedMiles: state.rewards && state.rewards.earnedMile && state.rewards.earnedMile.toString()
  }
}

export default withRouter(
  connect(mapStateToProps, { getRewards, getEarnedMiles })(withTranslation("rewards")(Rewards))
)
